import tokens from '@lansforsakringar/core-tokens'
import { css } from 'lit'

import { vars, scoped } from '#utils/styles'

const locals = scoped('navigation-list-row', [
	'background_color',
	'border_color',
	'color',
	'color_secondary'
] as const)

export default css`
	:host {
		display: block;
		width: 100%;
		container-type: inline-size;
	}

	.content {
		display: grid;
		flex-grow: 1;
		align-items: stretch;
		gap: 0 ${vars(tokens.spacing_lg)};
		grid-template-columns: minmax(0, 1fr) minmax(0, fit-content(60%));
		grid-template-rows: auto auto;
	}

	.label-start,
	.sub-label-start,
	.label-end,
	.sub-label-end {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		min-width: 0;
	}

	.label-start,
	.sub-label-start {
		grid-column: 1;
	}

	.label-end,
	.sub-label-end {
		grid-column: 2;
		align-items: flex-end;
		text-align: end;
	}

	.label-start {
		grid-row: 1;
	}

	.sub-label-start {
		grid-row: 2;
	}

	.label-end {
		grid-row: 1;
	}

	.sub-label-end {
		grid-row: 2;
	}

	:host([data-has-label-start='false']) .label-start,
	:host([data-has-sub-label-start='false']) .sub-label-start,
	:host([data-has-label-end='false']) .label-end,
	:host([data-has-sub-label-end='false']) .sub-label-end {
		display: none;
	}

	/* Center align the label if only one label is in the column. */
	:host([data-has-label-start='true'][data-has-sub-label-start='false'])
		.label-start,
	:host([data-has-label-start='false'][data-has-sub-label-start='true'])
		.sub-label-start,
	:host([data-has-label-end='true'][data-has-sub-label-end='false']) .label-end,
	:host([data-has-label-end='false'][data-has-sub-label-end='true'])
		.sub-label-end {
		grid-row: 1 / 3;
		justify-content: center;
	}

	/* Vertical align to the start when both labels in a column is used. */
	:host([data-has-label-start='true'][data-has-sub-label-start='true'])
		.label-start,
	:host([data-has-label-start='true'][data-has-sub-label-start='true'])
		.sub-label-start,
	:host([data-has-label-end='true'][data-has-sub-label-end='true']) .label-end,
	:host([data-has-label-end='true'][data-has-sub-label-end='true'])
		.sub-label-end {
		justify-content: flex-start;
	}

	@container (max-width: 17em) {
		.content {
			display: flex;
			flex-direction: column;
			gap: 0;
		}

		.label-start,
		.sub-label-start,
		.label-end,
		.sub-label-end {
			width: 100%;
			justify-content: flex-start;
			align-items: flex-start;
			text-align: start;
			margin: 0;
		}

		:host(:is([data-has-label-start='true'], [data-has-sub-label-start='true']))
			.label-end {
			margin-top: ${vars(tokens.spacing_sm)};
		}

		:host([data-has-label-start='false'][data-has-sub-label-start='false'])
			.label-end {
			margin-top: 0;
		}
	}

	slot[name='label-start'] {
		font-size: ${vars(tokens.text_size_label_default)};
		font-weight: ${vars(tokens.font_weight_regular)};
		line-height: ${vars(tokens.line_height_label_default)};
		color: ${vars(locals.color)};
		overflow-wrap: break-word;
		word-break: break-word;
	}

	slot[name='sub-label-start'] {
		font-size: ${vars(tokens.text_size_label_sm)};
		font-weight: ${vars(tokens.font_weight_regular)};
		line-height: ${vars(tokens.line_height_label_sm)};
		color: ${vars(locals.color_secondary)};
		overflow-wrap: break-word;
		word-break: break-word;
	}

	slot[name='label-end'] {
		font-size: ${vars(tokens.text_size_label_default)};
		font-weight: ${vars(tokens.font_weight_regular)};
		line-height: ${vars(tokens.line_height_label_default)};
		color: ${vars(locals.color)};
		overflow-wrap: break-word;
		word-break: break-word;
	}

	slot[name='sub-label-end'] {
		font-size: ${vars(tokens.text_size_label_sm)};
		font-weight: ${vars(tokens.font_weight_regular)};
		line-height: ${vars(tokens.line_height_label_sm)};
		color: ${vars(locals.color_secondary)};
		overflow-wrap: break-word;
		word-break: break-word;
	}
`
